import { httpCreate } from './http';

const http = httpCreate('/srv/service-mch-account');

export const serviceMchAccount = {
	// 申请服务商账户
	apply(data) {
		return http.post(`/apply`, data);
	},
	// 服务商账户列表
	list(params) {
		return http.get(`/list`, { params });
	},
	// 服务商账户申请列表
	applyList(params) {
		return http.get(`/applyList`, { params });
	},
	// 设置为收款商户
	setMerchant(id, openStatus) {
		return http.put(`/setMerchant/${id}/${openStatus}`);
	},
	// 获取账户验证/签约链接
	signUrl(id) {
		return http.get(`/sign-url/${id}`);
	},
	// 查看申请单详情
	info(id) {
		return http.get(`/${id}`);
	},
	// 商户下拉列表
	titleList() {
		return http.get(`/titleList`);
	},
	// 获取有效服务商户
	getValidMch() {
		return http.get(`/getValidMch`);
	},
};
